import { normalizeTheme, THEME_QUERY_PARAM } from 'Utils/theme';

const THEME_PARAM_PATTERN = new RegExp(`([?&])${THEME_QUERY_PARAM}=[^&#]*`);

// URL parse edilmez: query yeniden serilestirilirse (%20 -> + vb.) backend'in
// URL'i byte-for-byte korunmaz ve relative URL'lerde new URL firlatir.
// Bu yuzden yalnizca theme parami string seviyesinde ezilir/eklenir.
export const applyThemeToWidgetUrl = (url, theme) => {
  if (!url) return url;

  const themeParam = `${THEME_QUERY_PARAM}=${normalizeTheme(theme)}`;

  if (THEME_PARAM_PATTERN.test(url)) {
    return url.replace(THEME_PARAM_PATTERN, `$1${themeParam}`);
  }

  const hashIndex = url.indexOf('#');
  const base = hashIndex === -1 ? url : url.slice(0, hashIndex);
  const hash = hashIndex === -1 ? '' : url.slice(hashIndex);
  const separator = base.includes('?') ? '&' : '?';

  return `${base}${separator}${themeParam}${hash}`;
};
